import usePagesScreen from './pages/usePagesScreen';
import PagesView from './pages/PagesView';
import AppSnackbar from '../components/ui/AppSnackbar';

/**
 * "Páginas e links" — CONTAINER.
 *
 * A lógica mora em `usePagesScreen`; a tradução para o ViewModel, em `pagesVmBuilder` (puro, e é
 * onde vivem os QUATRO estados de página). Aqui só ficam os fios.
 *
 * ⚠️ Sem `PageLayout`: a `PagesView` desenha a página inteira, cabeçalho incluído. Envolver
 * duplicaria o título — mesmo padrão de Ausências, Suporte e da Home.
 *
 * ⚠️ O feedback efêmero (copiou o link, publicou) é renderizado AQUI, não na View. O Admin
 * padroniza toda confirmação no `AppSnackbar` — posição, tempo e aparência iguais em ~19 telas —
 * e o eslint proíbe `Snackbar` cru justamente para as telas não divergirem.
 */
export default function PagesPage() {
  const { vm, actions } = usePagesScreen();

  return (
    <>
      <PagesView vm={vm} actions={actions} />

      <AppSnackbar
        snackbar={{
          open: !!vm.feedback,
          message: vm.feedback?.message ?? '',
          severity: vm.feedback?.tone ?? 'success',
        }}
        onClose={actions.onDismissFeedback}
      />
    </>
  );
}
